<template>
  <!-- 簽名文件管理主頁面 -->
  <div v-loading="pageLoading" class="app-container">
    <!-- 文件清單檢視區域 -->
    <div :hidden="showDocument || dialogAssignFormVisible || dialogSignFormVisible">
      <el-row :gutter="20">
        <!-- 左側簽署者列表 -->
        <el-col :xl="4" :lg="4" :md="6" :sm="6" :xs="24">
          <div style="overflow-x: hidden; overflow-y: auto; height: 500px">
            <!-- 簽署者搜尋框 -->
            <el-input v-model="filterPatientText" placeholder="搜尋簽署者" clearable />

            <!-- 簽署者樹狀列表 -->
            <el-tree
              ref="tree"
              class="filter-tree"
              :data="patientTreeData"
              default-expand-all
              :filter-node-method="filterNode"
              :expand-on-click-node="false"
              node-key="ID"
              highlight-current
              @node-click="patientTreeNodeClick">
              <template slot-scope="{ data }">
                <div>
                  <span class="patient-name-text">{{ data.NAME + '_' + data.MEDICAL_RECORD_NO }}</span>
                  <!-- 顯示逾期待簽文件數量標記 -->
                  <el-badge
                    v-if="
                      list.filter(
                        (x) =>
                          (x.SIGNED_PDF_PATH === null || x.SIGNED_PDF_PATH === '') &&
                          x.PATIENT_ID === data.ID &&
                          isOverdue(x.DEADLINE_DATE)
                      ).length > 0
                    "
                    :value="
                      list.filter(
                        (x) =>
                          (x.SIGNED_PDF_PATH === null || x.SIGNED_PDF_PATH === '') &&
                          x.PATIENT_ID === data.ID &&
                          isOverdue(x.DEADLINE_DATE)
                      ).length
                    "
                    class="mark" />
                </div>
              </template>
            </el-tree>
          </div>
        </el-col>

        <!-- 右側文件列表 -->
        <el-col :xl="20" :lg="20" :md="18" :sm="18" :xs="24">
          <!-- 操作按鈕區 -->
          <div style="margin-bottom: 15px; display: flex">
            <div style="margin-right: 15px">
              <el-input v-model="listQuery.DOC_NAME" placeholder="搜尋文件名" @keyup.enter.native="handleFilter" />
            </div>

            <div>
              <el-button
                v-loading.fullscreen.lock="fullLoading"
                plain
                round
                icon="el-icon-search"
                @click="handleFilter">
                搜尋
              </el-button>
              <el-button icon="el-icon-refresh" @click="resetFormInfo"> 重置 </el-button>
              <el-button type="info" icon="el-icon-s-promotion" @click="handleSendToHCA"> 全部送簽 </el-button>
              <el-button
                v-loading.fullscreen.lock="fullLoading"
                type="danger"
                icon="el-icon-delete"
                @click="handleBatchDelete">
                刪除
              </el-button>
            </div>
          </div>

          <!-- 簽署者資訊顯示區 -->
          <div v-if="listQuery.PATIENT_ID" class="patient-info-bar">
            <el-tag type="primary" size="small" class="patient-name-tag">
              {{ patientTreeData.filter((x) => x.ID === listQuery.PATIENT_ID)[0].NAME }}
            </el-tag>
            <el-tag type="info" size="small">
              病歷號: {{ patientTreeData.filter((x) => x.ID === listQuery.PATIENT_ID)[0].MEDICAL_RECORD_NO }}
            </el-tag>
            <el-tag type="info" size="small">
              年齡: {{ getAge(patientTreeData.filter((x) => x.ID === listQuery.PATIENT_ID)[0].DATEOFBIRTH) }}
            </el-tag>
            <el-tag type="info" size="small">
              性別: {{ patientTreeData.filter((x) => x.ID === listQuery.PATIENT_ID)[0].SEX === 'M' ? '男性' : '女性' }}
            </el-tag>
          </div>

          <!-- 文件列表分頁 -->
          <el-tabs type="border-card" :before-leave="handleTabBeforeLeave">
            <!-- 已簽文件列表 -->
            <el-tab-pane label="已簽的文件">
              <el-table
                ref="signedTable"
                v-loading="listLoading"
                :data="signedlist"
                fit
                highlight-current-row
                border
                stripe
                row-key="ID"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50px" align="center" />
                <el-table-column label="序號" type="index" width="50px" align="center" />
                <el-table-column label="簽署者" prop="PATIENT_ID" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <span>{{
                      patientTreeData.filter((x) => x.ID === row.PATIENT_ID).length > 0
                        ? patientTreeData.filter((x) => x.ID === row.PATIENT_ID)[0].NAME +
                          '_' +
                          patientTreeData.filter((x) => x.ID === row.PATIENT_ID)[0].MEDICAL_RECORD_NO
                        : ''
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="簽名動態資訊" align="center" width="130px">
                  <template slot-scope="{ row }">
                    <el-button type="primary" plain size="mini" @click="showHandwritingInfo(row)">
                      簽名動態資訊
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column label="文件號碼" prop="DOC_NO" align="center" width="130px" show-overflow-tooltip />
                <el-table-column label="文件名" prop="DOC_NAME" align="center" width="165px" />
                <el-table-column label="文件版本" prop="VERSION" align="center" width="80px" />
                <el-table-column label="更新時間" prop="LAST_UPDATE_DATE" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <span>{{ row.LAST_UPDATE_DATE | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="申請單號"
                  prop="APPLY_SEQ"
                  align="center"
                  width="170px"
                  @selection-change="handleSelectionChange" />
                <el-table-column label="已送簽" prop="HCA_FLAG" align="center" width="75px">
                  <template slot-scope="{ row }">
                    <span>{{ row.HCA_FLAG === 'N' ? '否' : '是' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                  <template slot-scope="{ row }">
                    <el-button size="mini" @click="viewSignedDoc(row)"> 查看 </el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(row)"> 刪除 </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 已簽署文件分頁 -->
              <pagination
                v-show="signedtotal > 0"
                :total="signedtotal"
                :page.sync="signedPage"
                :limit.sync="signedLimit"
                @pagination="getSignedList" />
            </el-tab-pane>

            <!-- 待簽文件列表 -->
            <el-tab-pane>
              <span slot="label">
                待簽的文件
                <span v-if="overdueCount > 0" style="color: red">
                  {{ '(' + overdueCount + ')' }}
                </span>
              </span>
              <el-table
                ref="toBeSignedTable"
                v-loading="listLoading"
                :data="tobesignedlist"
                fit
                highlight-current-row
                border
                stripe
                row-key="ID"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50px" align="center" />
                <el-table-column label="序號" type="index" width="50px" align="center" />
                <el-table-column label="狀態" prop="STATUS" align="center" width="50px">
                  <template slot-scope="{ row }">
                    <span
                      :style="{
                        color: isOverdue(row.DEADLINE_DATE) ? 'red' : 'gray'
                      }">
                      {{ isOverdue(row.DEADLINE_DATE) ? '逾期' : '待簽' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="簽署者" prop="PATIENT_ID" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <span>{{
                      patientTreeData.filter((x) => x.ID === row.PATIENT_ID)[0].NAME +
                      '_' +
                      patientTreeData.filter((x) => x.ID === row.PATIENT_ID)[0].MEDICAL_RECORD_NO
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="文件號碼" prop="DOC_NO" align="center" width="150px" />
                <el-table-column label="文件名" prop="DOC_NAME" align="center" width="150px" />
                <el-table-column label="文件版本" prop="VERSION" align="center" width="100px" />
                <el-table-column label="更新時間" prop="LAST_UPDATE_DATE" align="center" width="150px">
                  <template slot-scope="{ row }">
                    <span>{{ row.LAST_UPDATE_DATE | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="申請單號" prop="APPLY_SEQ" align="center" width="200px" />

                <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                  <template slot-scope="{ row }">
                    <el-button size="mini" @click="showDocumentDialog(row)"> 查看 </el-button>
                    <el-button
                      v-if="isOverdue(row.DEADLINE_DATE)"
                      type="warning"
                      size="small"
                      @click="handleReassign(row)">
                      重新指派
                    </el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(row)"> 刪除 </el-button>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 待簽署文件分頁 -->
              <pagination
                v-show="tobesignedtotal > 0"
                :total="tobesignedtotal"
                :page.sync="unsignedPage"
                :limit.sync="unsignedLimit"
                @pagination="getUnsignedList" />
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>

    <!-- PDF文件預覽區 -->
    <div :hidden="!showDocument">
      <PDFWorkspace
        :key="designpdfKey"
        ref="designpdf"
        :data="pdfData"
        :is-view-mode="true"
        :is-assign="isDoctorFill"
        @assignDocument="assignDocument"
        @back="handleBack" />
    </div>

    <!-- 指派文件表單 -->
    <div :hidden="!dialogAssignFormVisible">
      <div class="action-bar">
        <el-button type="success" icon="el-icon-back" @click="dialogAssignFormVisible = false">返回</el-button>
      </div>
      <div style="padding-top: 20px; border: 1px solid #f1e8e8">
        <el-form
          ref="formRef"
          inline
          class="dialog-from-margin"
          style="padding-left: 20px"
          :rules="rules"
          status-icon
          :model="dataform"
          label-position="left"
          label-width="100px">
          <el-form-item label="簽署者" prop="PATIENT_ID">
            <el-select ref="patientSelect" v-model="dataform.PATIENT_ID" clearable placeholder="請選擇簽署者">
              <el-option
                v-for="item in patientTreeData"
                :key="item.ID"
                :label="item.NAME + '_' + item.MEDICAL_RECORD_NO"
                :value="item.ID"
                clearable />
            </el-select>
          </el-form-item>
          <el-form-item label="申請單號" prop="APPLY_SEQ">
            <el-input v-model="dataform.APPLY_SEQ" placeholder="請輸入申請單號" clearable style="width: 300px" />
          </el-form-item>
        </el-form>
        <docTemplates :is-assign="true" @assignDoc="createData" />
      </div>
    </div>

    <!-- 簽名動態資訊顯示區 -->
    <div :hidden="!dialogSignFormVisible">
      <div class="action-bar">
        <el-button type="primary" icon="el-icon-back" @click="dialogSignFormVisible = false">返回</el-button>
      </div>
      <HandwritingInfo :key="signTemplatesKey" :data="patientSignData" />
    </div>

    <!-- 送簽結果 Dialog -->
    <el-dialog
      title="送簽結果"
      :visible.sync="dialogSendResultVisible"
      width="600px"
      :close-on-click-modal="false"
      :show-close="false">
      <div v-if="sendResult">
        <!-- 成功結果 -->
        <div v-if="sendResult.success.length" style="margin-bottom: 20px">
          <el-alert
            :title="`${sendResult.success.length} 筆送簽成功`"
            type="success"
            :closable="false"
            style="margin-bottom: 10px" />
          <el-table :data="sendResult.success" border size="small" max-height="200">
            <el-table-column type="index" label="序號" width="60" align="center" />
            <el-table-column prop="applySeq" label="申請單號" />
          </el-table>
        </div>

        <!-- 失敗結果 -->
        <div v-if="sendResult.fail.length">
          <el-alert
            :title="`${sendResult.fail.length} 筆送簽失敗`"
            type="error"
            :closable="false"
            style="margin-bottom: 10px" />
          <el-table :data="sendResult.fail" border size="small" max-height="200">
            <el-table-column type="index" label="序號" width="60" align="center" />
            <el-table-column prop="applySeq" label="申請單號" />
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSendResultVisible = false">關閉</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PDFWorkspace from '@/components/PDFWorkspace'
import docTemplates from '@/views/Documents/index.vue'
import HandwritingInfo from '@/components/HandwritingInfo'
import { asigndocsInfo, createAsigndocs, updateAsigndocs, deleteAsigndocs, sendToHCAEMR } from '@/api/asigndocs'
import { deepClone } from '@/utils/index'
import { patientInfo } from '@/api/patients'
import Pagination from '@/components/Pagination'

export default {
  name: 'SignerDocs',
  components: { Pagination, docTemplates, PDFWorkspace, HandwritingInfo },
  data() {
    return {
      signedlist: [],
      signedtotal: 0,
      tobesignedlist: [],
      tobesignedtotal: 0,
      list: [],
      total: 0,

      signedPage: 1,
      signedLimit: 10,
      unsignedPage: 1,
      unsignedLimit: 10,

      showDocument: false,
      designpdfKey: +new Date(),
      pdfData: {},

      isDoctorFill: false,

      printLoading: false,
      listLoading: true,
      fullLoading: false,
      pageLoading: false,
      listQuery: {
        PATIENT_ID: undefined,
        DOC_NAME: undefined
      },
      filterPatientText: '',
      patientTreeData: [],
      dataform: {
        ID: undefined,
        APPLY_SEQ: undefined,
        PATIENT_ID: undefined,
        FOLDER_ID: undefined,
        DOC_NO: undefined,
        DOC_NAME: undefined,
        VERSION: undefined,
        DOC_ID: undefined,
        SIGN_DATA: undefined,
        DEADLINE_DATE: undefined,
        DEADLINE_DAYS: undefined
      },
      dialogAssignFormVisible: false,
      dialogSignFormVisible: false,
      patientSignData: undefined,
      signTemplatesKey: +new Date(),

      dialogSendResultVisible: false,
      sendResult: null,

      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules: {
        PATIENT_ID: [{ required: true, message: '請選擇簽署者', trigger: 'blur' }],
        APPLY_SEQ: [{ required: true, message: '請輸入申請單號', trigger: 'blur' }]
      },
      multipleSelection: []
    }
  },
  computed: {
    ...mapGetters(['USERNAME', 'token']),
    overdueCount() {
      return this.tobesignedlist.filter((x) => this.isOverdue(x.DEADLINE_DATE)).length
    }
  },
  watch: {
    filterPatientText(val) {
      this.$refs.tree.filter(val)
    }
  },
  created() {
    // window.localStorage.setItem("printdone", 'false')
    this.getPatientTree()
    this.getList()
  },
  beforeDestroy() {},
  methods: {
    /**
     * 獲取已簽署文件列表
     * @returns {Promise} API 響應
     */
    async getSignedList() {
      const params = {
        page: this.signedPage,
        limit: this.signedLimit,
        PATIENT_ID: this.listQuery.PATIENT_ID,
        DOC_NAME: this.listQuery.DOC_NAME,
        SIGNED_FLAG: 'Y',
        ORDER_BY: 'LAST_UPDATE_DATE',
        ORDER_DIR: 'DESC'
      }

      const response = await asigndocsInfo(params)
      this.signedlist = response.data.result.rows
      this.signedtotal = response.data.result.count
      return response
    },

    // 獲取待簽署文件列表
    async getUnsignedList() {
      const params = {
        page: this.unsignedPage,
        limit: this.unsignedLimit,
        PATIENT_ID: this.listQuery.PATIENT_ID,
        DOC_NAME: this.listQuery.DOC_NAME,
        SIGNED_FLAG: 'N',
        // 不設定 OVERDUE_FLAG，包含逾期和未逾期文件
        ORDER_BY: 'LAST_UPDATE_DATE',
        ORDER_DIR: 'DESC'
      }

      const response = await asigndocsInfo(params)
      this.tobesignedlist = response.data.result.rows
      this.tobesignedtotal = response.data.result.count
      return response
    },

    // 獲取所有列表數據
    async getList() {
      this.listLoading = true

      try {
        // 並行獲取已簽署和待簽署文件
        await Promise.all([this.getSignedList(), this.getUnsignedList()])

        // 合併結果用於相容性（如果需要）
        this.list = [...this.signedlist, ...this.tobesignedlist]
        this.total = this.signedtotal + this.tobesignedtotal
      } catch (error) {
        this.$message.error('載入資料失敗，請稍後重試')
      } finally {
        this.listLoading = false
      }
    },
    async handleFilter() {
      this.signedPage = 1
      this.unsignedPage = 1
      await this.getList()
    },
    resetTemp() {
      this.dataform = {
        ID: undefined,
        APPLY_SEQ: undefined,
        PATIENT_ID: undefined,
        DOC_ID: undefined,
        DOC_NO: undefined,
        DOC_NAME: undefined,
        VERSION: undefined,
        SIGN_DATA: undefined,
        DEADLINE_DATE: undefined,
        DEADLINE_DAYS: undefined
      }
    },
    getAge(dateString) {
      const today = new Date()
      const birthDate = new Date(dateString)
      let age = today.getFullYear() - birthDate.getFullYear()
      const m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    /**
     * 判斷是否逾期
     * @param {string|Date} deadlineDate - 截止日期
     * @returns {boolean} 是否逾期
     */
    isOverdue(deadlineDate) {
      if (!deadlineDate) return false

      // 統一轉換為日期物件進行比較
      const deadline = new Date(deadlineDate)
      const today = new Date()

      // 設定為當天的 00:00:00 進行日期比較
      today.setHours(0, 0, 0, 0)
      deadline.setHours(0, 0, 0, 0)

      // 如果截止日期 < 今天，則逾期
      return deadline < today
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogAssignFormVisible = true
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    createData(row) {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dataform.DOC_ID = row.ID
          this.dataform.FOLDER_ID = row.FOLDER_ID
          this.dataform.DOC_NO = row.DOC_NO
          this.dataform.DOC_NAME = row.DOC_NAME
          this.dataform.VERSION = row.VERSION
          this.dataform.SIGN_DATA = row.SIGN_DATA

          this.pdfData.ID = row.ID
          this.pdfData.PATIENT_DATA = this.patientTreeData.filter((x) => x.ID === this.dataform.PATIENT_ID)[0]
          this.pdfData.SIGN_DATA = this.dataform.SIGN_DATA
          this.pdfData.TEMPLATE_PATH = `/api/files/template/${row.ID}`

          this.isDoctorFill = true
          this.dialogAssignFormVisible = false
          this.designpdfKey = +new Date()
          this.showDocument = true
        }
      })
    },
    assignDocument(SIGN_DATA, deadlineDate, deadlineDays) {
      this.dataform.DEADLINE_DATE = deadlineDate
      this.dataform.DEADLINE_DAYS = deadlineDays
      this.dataform.SIGN_DATA = SIGN_DATA

      if (this.dialogStatus === 'create') {
        this.fullLoading = true
        const tempDataForm = Object.assign({}, this.dataform)

        createAsigndocs(tempDataForm)
          .then(() => {
            this.fullLoading = false
            this.dialogFormVisible = false
            this.showDocument = false
            this.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })

            this.getList()
          })
          .catch(() => {
            this.fullLoading = false
            this.dialogFormVisible = false
            this.showDocument = false
          })
      } else {
        const tempData = Object.assign({}, this.dataform)
        this.fullLoading = true
        updateAsigndocs(tempData)
          .then(() => {
            this.fullLoading = false
            this.dialogFormVisible = false
            this.showDocument = false
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
          .catch(() => {
            this.fullLoading = false
            this.dialogFormVisible = false
            this.showDocument = false
          })
      }
    },
    handleBack() {
      this.showDocument = false
      if (this.dialogStatus === 'create') {
        this.dialogAssignFormVisible = true
      }
    },
    showDocumentDialog(row) {
      this.pdfData = row
      // 使用新的 API：待簽署文件（asign_doc.TOBESIGNED_PDF_PATH）
      this.pdfData.TEMPLATE_PATH = `/api/files/tobesigned/${row.ID}`

      this.isDoctorFill = false
      this.designpdfKey = +new Date()
      this.showDocument = true
      this.dialogAssignFormVisible = false
      this.dialogStatus = ''
    },
    handleReassign(row) {
      this.dialogStatus = 'update'

      this.dataform.ID = row.ID
      this.dataform.PATIENT_ID = row.PATIENT_ID
      this.dataform.DOC_NO = row.DOC_NO
      this.dataform.DOC_NAME = row.DOC_NAME
      this.dataform.VERSION = row.VERSION
      this.dataform.SIGN_DATA = row.SIGN_DATA

      this.pdfData.ID = row.ID
      this.pdfData.PATIENT_DATA = this.patientTreeData.filter((x) => x.ID === this.dataform.PATIENT_ID)[0]
      this.pdfData.SIGN_DATA = this.dataform.SIGN_DATA
      this.pdfData.TEMPLATE_PATH = `/api/files/tobesigned/${row.ID}`

      this.isDoctorFill = true
      this.dialogAssignFormVisible = false
      this.designpdfKey = +new Date()
      this.showDocument = true
    },
    showHandwritingInfo(row) {
      this.dialogSignFormVisible = true
      this.patientSignData = deepClone(row)
      this.patientSignData.PATIENT_NAME = this.patientTreeData.filter((x) => x.ID === row.PATIENT_ID)[0].NAME
      this.signTemplatesKey = +new Date()
    },
    viewSignedDoc(row) {
      // 統一使用 Dialog 內部預覽，不使用 window.open
      if (row.SIGNED_PDF_PATH) {
        this.pdfData = row
        this.pdfData.TEMPLATE_PATH = `/api/files/signed/${row.ID}`
        this.isDoctorFill = false
        this.designpdfKey = +new Date()
        this.showDocument = true
        this.dialogAssignFormVisible = false
        this.dialogStatus = ''
      }
    },
    /**
     * 檢視待簽署文件（Dialog 內部預覽）
     * @param {Object} row - 簽署任務記錄
     */
    viewTobesignedDoc(row) {
      this.showDocumentDialog(row)
    },
    handleDelete(row) {
      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(() => {
          this.fullLoading = true
          deleteAsigndocs(row.ID)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleBatchDelete() {
      if (!this.multipleSelection.length) {
        this.$message({ type: 'info', message: '請勾選你要刪除的數據' })
        return
      }

      this.$confirm('確認刪除該記錄？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.fullLoading = true
          const promises = []

          this.multipleSelection.forEach((id) => {
            promises.push(deleteAsigndocs(id))
          })

          Promise.all(promises)
            .then(() => {
              this.fullLoading = false
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
                duration: 2000
              })
              this.handleFilter()
            })
            .catch(() => {
              this.fullLoading = false
            })
        })
        .catch(() => {
          // 不執行任何動作
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.ID)
    },
    handleTabBeforeLeave() {
      // 清空 Table 的勾選
      if (this.$refs.signedTable) {
        this.$refs.signedTable.clearSelection()
      }

      if (this.$refs.toBeSignedTable) {
        this.$refs.toBeSignedTable.clearSelection()
      }
    },
    resetFormInfo() {
      this.$refs.tree.setCurrentKey(null)
      this.listQuery.PATIENT_ID = undefined
      this.listQuery.DOC_NAME = undefined
      this.getList()
    },
    /**
     * 獲取病患樹狀結構
     */
    getPatientTree() {
      patientInfo().then((response) => {
        this.patientTreeData = response.data.result.rows
      })
    },
    filterNode(value, data, node) {
      if (!value) return true
      return (data.NAME + '_' + data.MEDICAL_RECORD_NO).toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) !== -1
    },
    patientTreeNodeClick(data) {
      this.listQuery.PATIENT_ID = data.ID
      this.handleFilter()
    },
    handleSendToHCA() {
      this.pageLoading = true
      sendToHCAEMR()
        .then((res) => {
          this.$message.info(res.message)

          // 統一用 dialog 顯示送簽結果
          if (res.data.success.length || res.data.fail.length) {
            this.sendResult = {
              success: res.data.success.map((applySeq) => ({ applySeq })),
              fail: res.data.fail.map((applySeq) => ({ applySeq }))
            }
            this.dialogSendResultVisible = true
          }

          this.getList()
        })
        .catch((err) => {
          this.$notify({
            title: '批量送簽發生錯誤',
            message: err,
            type: 'error',
            duration: 20000
          })
        })
        .finally(() => {
          this.pageLoading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-expand-title {
  font-size: 0;

  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  /deep/ label {
    color: #99a9bf;
  }
}

.filter-tree {
  margin-top: 2vh;
  overflow-x: hidden;
}

::v-deep .filter-tree .el-tree-node__content {
  overflow-x: hidden;
}

.patient-name-text {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  max-width: 100%;
}

.patient-info-bar {
  padding: 8px 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

// 減少分頁組件的上下空間
::v-deep .pagination-container {
  padding: 20px 16px 0 16px;
  margin-top: 0;
  margin-bottom: 0;
}

// 讓 el-tabs 內容區域可以滾動，滾動條顯示在 Card 內部
::v-deep .el-tabs--border-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 252px);
  overflow: hidden;
}

::v-deep .el-tabs--border-card .el-tabs__content {
  flex: 1;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs--border-card .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 表格區域可滾動，分頁固定在底部
::v-deep .el-tabs--border-card .el-tab-pane {
  .el-table {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }

  .pagination-container {
    flex-shrink: 0;
    position: relative;
  }
}

.tags-margin {
  margin-right: 0.5vw;
}

@import '@/styles/stylesForm/home.scss';
@import '@/styles/stylesForm/mixin.scss';

@include action-bar;
::v-deep .el-drawer__header {
  display: none;
}

.action-bar {
  background: #fff;
  border: none;
  padding-bottom: 1em;
  text-align: left;
}
</style>
